module.exports = __webpack_public_path__ + "static/media/icn-finances.fc362064.svg";